import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field } from "formik";
import {
  AdminVaultForgotPass,
  AdminVaultLogin,
  AdminVaultOtp,
  AdminVaultUpdatePassOtpVerify,
} from "../../../Api/SuperAdminVault/VaultLoginApi";
import { toast } from "react-toastify";
import { Spin } from "antd";
import { IoMdEye } from "react-icons/io";
import { IoMdEyeOff } from "react-icons/io";
import ModalPopup from "../../Common/Modal/Modal";

const OTP_INITIAL_VALUES = { otp: ["", "", "", "", "", ""] };
const VaultLoginPage = ({ setIsVaultAuthenticated, authLoading }) => {
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showResendOtp, setShowResendOtp] = useState(false);
  const [timeLeft, setTimeLeft] = useState(2 * 60); //5 * 60
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [challengeId, setChallengeId] = useState("");
  const [loginValues, setLoginValues] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showForgotPass, setShowForgotPass] = useState(false);
  const [isUpdatePassTriggered, setIsUpdatePassTriggered] = useState(false)

  useEffect(() => {
    if (!showOtpScreen) return;
    let timer;

    if (timeLeft > 0 && !showResendOtp) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setShowResendOtp(true);
    }

    return () => clearInterval(timer);
  }, [timeLeft, showResendOtp, showOtpScreen]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  const otpRefs = useRef([]);

  const handleLoginSubmit = async (values) => {
    try {
      setLoading(true);
      setLoginValues(values);

      const data = await AdminVaultLogin(values);
      const challenge_id = data?.challengeId;
      console.log("Login Values:", data);
      setChallengeId(challenge_id);
      if (data !== undefined) {
        setShowOtpScreen(true);

        setTimeout(() => {
          otpRefs.current[0]?.focus();
        }, 100);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;
    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);
    if (value && index < 5) otpRefs.current[index + 1]?.focus();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const updatedOtp = [...otp];
        updatedOtp[index] = "";
        setOtp(updatedOtp);
        return;
      }
      if (index > 0) otpRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedOtp = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 6);
    if (!pastedOtp) return;
    const updatedOtp = ["", "", "", "", "", ""];
    pastedOtp.split("").forEach((digit, index) => {
      updatedOtp[index] = digit;
    });
    setOtp(updatedOtp);
  };

  const handleOtpSubmit = async () => {
    try {
      setLoading(true);

      const otpValue = otp.join("");

      console.log("OTP:", otpValue);
      if(isUpdatePassTriggered) {
        AdminVaultUpdatePassOtpVerify(forgotFormData,otpValue,challengeId)
        setOtp(["","","","","",""])
        setShowOtpScreen(false)
      } else {
        AdminVaultOtp(otpValue, challengeId, setIsVaultAuthenticated);
      }
      setIsUpdatePassTriggered(false)
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = () => {
    console.log("Forgot Password");
    setShowForgotPass(true);
  };

  

  const handleResendOtp = () => {
    console.log("Resend OTP");
    setShowResendOtp(false);
    setTimeLeft(2 * 60);
    handleLoginSubmit(loginValues);
  };
  const [forgotFormData, setForgotFormData] = useState({
    email: "",
    password: "",
  });

  const handleForgotPassClose = () => {
    setShowForgotPass(false);
    setForgotFormData({
    email: "",
    password: "",
  })
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForgotFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleForgotSubmit = async(e) => {
    e.preventDefault();

    // handleLoginSubmit(forgotFormData);
    const response = await AdminVaultForgotPass(forgotFormData,setShowOtpScreen,setForgotFormData,setShowForgotPass)
    const challenge_id = response?.challengeId;    
      setChallengeId(challenge_id);
    setIsUpdatePassTriggered(true)
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#e2faf2]">
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-lg">
        {authLoading && (
          <div className="absolute inset-0 bg-[#e2faf2] z-20 flex items-center justify-center">
            <Spin size="large" />
          </div>
        )}
        {!showOtpScreen ? (
          <Formik
            initialValues={{
              email: "",
              password: "",
            }}
            onSubmit={handleLoginSubmit}
          >
            <Form className="space-y-4">
              <h2 className="text-[#1f4b7f] font-semibold text-2xl text-center">
                CRM Vault Login
              </h2>

              <div className="flex flex-col gap-2">
                <label className="text-[#1f4b7f]">Email</label>
                <Field
                  name="email"
                  type="email"
                  placeholder="Enter Email"
                  className="border-[0.2px] border-black rounded-md px-2 py-1"
                />
              </div>

              <div className="flex flex-col gap-2">
                <label className="text-[#1f4b7f]">Password</label>
                <div className="relative flex items-center">
                  <Field
                    name="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter Password"
                    className="border-[0.2px] border-black rounded-md px-2 py-1 pr-8 w-full"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="absolute right-2 flex items-center justify-center w-5 h-5"
                  >
                    {showPassword ? <IoMdEye /> : <IoMdEyeOff />}
                  </button>
                </div>
              </div>

              <div className="flex flex-col items-center gap-2">
                <button
                  type="button"
                  onClick={handleForgotPassword}
                  className="flex self-end underline"
                >
                  Forgot Password?
                </button>

                <button
                  type="submit"
                  disabled={loading}
                  className="bg-[#1f4b7f] text-white px-2 py-1 rounded-md w-[55%] mt-2"
                >
                  {loading ? "Verifying..." : "Enter the Vault"}
                </button>
              </div>
            </Form>
          </Formik>
        ) : (
          <div className="space-y-4">
            <div className="flex justify-between">
              <button
                type="button"
                onClick={() => {
                  setShowOtpScreen(false);
                  setTimeLeft(5 * 60);
                  setOtp(["", "", "", "", "", ""]);
                  setForgotFormData({email:"",password:""})
                }}
                className="bg-[#1f4b7f] text-white pl-4 pr-2 py-1 rounded-r-md back-button"
              >
                Back
              </button>

              {!showResendOtp && (
                <p className="text-center text-gray-600">
                  Resend OTP in {formatTime(timeLeft)}
                </p>
              )}
            </div>

            <h2 className="text-[#1f4b7f] font-semibold text-2xl text-center">
              OTP Verification
            </h2>

            <p>Enter the 6-digit OTP sent to your registered mobile number.</p>

            <div className="flex justify-center gap-3" onPaste={handlePaste}>
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => (otpRefs.current[index] = el)}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  className="w-10 h-10 border-2 border-gray-400 rounded-md p-2 text-xl text-center"
                />
              ))}
            </div>

            {!showResendOtp ? (
              <button
                type="button"
                disabled={otp.join("").length !== 6 || loading}
                onClick={handleOtpSubmit}
                className="bg-[#1f4b7f] text-white px-2 py-1 rounded-md block mx-auto"
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </button>
            ) : (
              <button
                type="button"
                onClick={handleResendOtp}
                className="bg-[#1f4b7f] text-white px-2 py-1 rounded-md block mx-auto"
              >
                Resend OTP
              </button>
            )}
          </div>
        )}
      </div>

      <ModalPopup show={showForgotPass} onClose={handleForgotPassClose}>
        <div className="min-h-[25vw] min-w-[35vw]">
          <form onSubmit={handleForgotSubmit} className="flex flex-col justify-center min-h-[25vw] gap-5">
            <h2 className="text-[#1f4b7f] font-semibold text-2xl text-center">
              Reset Vault Password
            </h2>

            <div className="flex flex-col gap-2">
              <label className="text-[#1f4b7f]">Email</label>
              <input
                name="email"
                type="email"
                placeholder="Enter Email"
                value={forgotFormData.email}
                onChange={handleChange}
                className="border-[0.2px] border-black rounded-md px-2 py-1"
              />
            </div>

            <div className="flex flex-col gap-2">
              <label className="text-[#1f4b7f]">New Password</label>

              <div className="relative flex items-center">
                <input
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter New Password"
                  value={forgotFormData.password}
                  onChange={handleChange}
                  className="border-[0.2px] border-black rounded-md px-2 py-1 pr-8 w-full"
                />

                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute right-2 flex items-center justify-center w-5 h-5"
                >
                  {showPassword ? <IoMdEye /> : <IoMdEyeOff />}
                </button>
              </div>
            </div>

            <div className="flex flex-col items-center gap-2">
              <button
                type="submit"
                disabled={loading}
                className="bg-[#1f4b7f] text-white px-2 py-1 rounded-md w-[55%] mt-2"
              >
                {loading ? "Verifying..." : "Update Password"}
              </button>
            </div>
            <p className="text-center">⚠ Changing your password will sign you out of all devices.</p>
          </form>
        </div>
      </ModalPopup>
    </div>
  );
};

export default VaultLoginPage;
